import { AccountSummary } from '@quick/client';
import React from 'react';
import AvatarStatus from '../../../components/shared-components/AvatarStatus';
import Icon, { ForestIcon } from '../../app-views/components/Icon';

interface AccountInfoOverviewProps {
  account: AccountSummary;
  hideAddress?: boolean;
}

const AccountInfoOverview: React.FC<AccountInfoOverviewProps> = ({ hideAddress, account }) => {
  return (
    <AvatarStatus
      icon={<Icon name={accountAvatar(account.accountId)} />}
      type="primary"
      name={<span className="label-s">{account.name}</span>}
      subtitle={!hideAddress ? account.address : undefined}
    />
  );
};

const accountAvatar = (accountId: number): ForestIcon => {
  const avatarNumber = (accountId % 8) + 1;
  return `community-avatar-${avatarNumber}` as ForestIcon;
};

export default AccountInfoOverview;
